import { DefaultColorPalette } from '../types/defaultColorPalette';
import { DEFAULT_ELEMENT_COLOR_PALETTES } from './defaultElementColorPalettes';

export const DEFAULT_FIRM_COLOR_PALETTES: DefaultColorPalette[] = [
  {
    inputColorHex: '#ffbe00',
    inputColorName: 'Amber',
    shades: [
      { name: '100', hex: '#fffeea' },
      { name: '200', hex: '#fffbc5' },
      { name: '300', hex: '#fff785' },
      { name: '400', hex: '#ffed46' },
      { name: '500', hex: '#ffde1b' },
      { name: '600', hex: '#ffbe00' },
      { name: '700', hex: '#e29200' },
      { name: '800', hex: '#bb6802' },
      { name: '900', hex: '#985008' },
      { name: '1000', hex: '#7c410b' },
      { name: '1100', hex: '#482100' },
    ],
  },
  {
    inputColorHex: '#ff8c0e',
    inputColorName: 'west-side',
    shades: [
      { name: '100', hex: '#fff9ed' },
      { name: '200', hex: '#fff2d4' },
      { name: '300', hex: '#ffe1a8' },
      { name: '400', hex: '#ffca70' },
      { name: '500', hex: '#ffa837' },
      { name: '600', hex: '#ff8c0e' },
      { name: '700', hex: '#f07006' },
      { name: '800', hex: '#c75507' },
      { name: '900', hex: '#9e420e' },
      { name: '1000', hex: '#7f390f' },
      { name: '1100', hex: '#451a05' },
    ],
  },
  {
    inputColorHex: '#ff4f03',
    inputColorName: 'international-orange',
    shades: [
      { name: '100', hex: '#fff6ec' },
      { name: '200', hex: '#ffebd3' },
      { name: '300', hex: '#ffd3a5' },
      { name: '400', hex: '#ffb46d' },
      { name: '500', hex: '#ff8932' },
      { name: '600', hex: '#ff670a' },
      { name: '700', hex: '#ff4f03' },
      { name: '800', hex: '#cc3502' },
      { name: '900', hex: '#a12a0b' },
      { name: '1000', hex: '#82250c' },
      { name: '1100', hex: '#460f04' },
    ],
  },
  {
    inputColorHex: '#c036dd',
    inputColorName: 'fuchsia-pink',
    shades: [
      { name: '100', hex: '#fcf4ff' },
      { name: '200', hex: '#f9e8ff' },
      { name: '300', hex: '#f2cfff' },
      { name: '400', hex: '#ecaafd' },
      { name: '500', hex: '#e178fa' },
      { name: '600', hex: '#cf44f1' },
      { name: '700', hex: '#c036dd' },
      { name: '800', hex: '#991ab1' },
      { name: '900', hex: '#7f1890' },
      { name: '1000', hex: '#6b1976' },
      { name: '1100', hex: '#46034f' },
    ],
  },
  {
    inputColorHex: '#8b31f1',
    inputColorName: 'electric-violet',
    shades: [
      { name: '100', hex: '#f9f5ff' },
      { name: '200', hex: '#f2e7ff' },
      { name: '300', hex: '#e7d3ff' },
      { name: '400', hex: '#d4b1ff' },
      { name: '500', hex: '#b980ff' },
      { name: '600', hex: '#9e4ffd' },
      { name: '700', hex: '#8b31f1' },
      { name: '800', hex: '#741cd4' },
      { name: '900', hex: '#631cad' },
      { name: '1000', hex: '#52188b' },
      { name: '1100', hex: '#350467' },
    ],
  },
  {
    inputColorHex: '#284ecd',
    inputColorName: 'cerulean-blue',
    shades: [
      { name: '100', hex: '#f0f6fe' },
      { name: '200', hex: '#dde9fc' },
      { name: '300', hex: '#c3d9fa' },
      { name: '400', hex: '#99c2f7' },
      { name: '500', hex: '#69a2f1' },
      { name: '600', hex: '#4680eb' },
      { name: '700', hex: '#3161df' },
      { name: '800', hex: '#284ecd' },
      { name: '900', hex: '#2741a6' },
      { name: '1000', hex: '#243a84' },
      { name: '1100', hex: '#1b2550' },
    ],
  },
  {
    inputColorHex: '#31948f',
    inputColorName: 'lochinvar',
    shades: [
      { name: '100', hex: '#f2fbfa' },
      { name: '200', hex: '#d5f2ee' },
      { name: '300', hex: '#aae5dc' },
      { name: '400', hex: '#78d0c7' },
      { name: '500', hex: '#4cb5ae' },
      { name: '600', hex: '#31948f' },
      { name: '700', hex: '#267b78' },
      { name: '800', hex: '#226362' },
      { name: '900', hex: '#1f504f' },
      { name: '1000', hex: '#1e4342' },
      { name: '1100', hex: '#0c2627' },
    ],
  },
  {
    inputColorHex: '#016e42',
    inputColorName: 'jewel',
    shades: [
      { name: '100', hex: '#ecfff6' },
      { name: '200', hex: '#d2ffed' },
      { name: '300', hex: '#a9ffdc' },
      { name: '400', hex: '#66ffc2' },
      { name: '500', hex: '#1dffa1' },
      { name: '600', hex: '#00f682' },
      { name: '700', hex: '#00ce68' },
      { name: '800', hex: '#00a055' },
      { name: '900', hex: '#007d47' },
      { name: '1000', hex: '#016e42' },
      { name: '1100', hex: '#003a20' },
    ],
  },
  {
    inputColorHex: '#a69259',
    inputColorName: 'teak',
    shades: [
      { name: '100', hex: '#f7f6ef' },
      { name: '200', hex: '#eae8d7' },
      { name: '300', hex: '#d7d1b1' },
      { name: '400', hex: '#bfb585' },
      { name: '500', hex: '#ad9d62' },
      { name: '600', hex: '#a69259' },
      { name: '700', hex: '#877147' },
      { name: '800', hex: '#6d583b' },
      { name: '900', hex: '#5d4a36' },
      { name: '1000', hex: '#514032' },
      { name: '1100', hex: '#2e231a' },
    ],
  },
  {
    inputColorHex: '#b78956',
    inputColorName: 'muddy-waters',
    shades: [
      { name: '100', hex: '#f8f4ee' },
      { name: '200', hex: '#ede4d4' },
      { name: '300', hex: '#dcc9ac' },
      { name: '400', hex: '#c8a77c' },
      { name: '500', hex: '#b78956' },
      { name: '600', hex: '#a8774a' },
      { name: '700', hex: '#915f3d' },
      { name: '800', hex: '#744934' },
      { name: '900', hex: '#623e31' },
      { name: '1000', hex: '#55352e' },
      { name: '1100', hex: '#311b17' },
    ],
  },
  {
    inputColorHex: '#b36d4f',
    inputColorName: 'santa-fe',
    shades: [
      { name: '100', hex: '#f9f5f1' },
      { name: '200', hex: '#eee2d7' },
      { name: '300', hex: '#dcc2ab' },
      { name: '400', hex: '#caa07f' },
      { name: '500', hex: '#be8561' },
      { name: '600', hex: '#b36d4f' },
      { name: '700', hex: '#9d5542' },
      { name: '800', hex: '#83423a' },
      { name: '900', hex: '#6c3734' },
      { name: '1000', hex: '#5a2e2d' },
      { name: '1100', hex: '#321716' },
    ],
  },
  {
    inputColorHex: '#b95b72',
    inputColorName: 'cadillac',
    shades: [
      { name: '100', hex: '#fbf4f7' },
      { name: '200', hex: '#f7ecf0' },
      { name: '300', hex: '#f1d9e2' },
      { name: '400', hex: '#e7bac9' },
      { name: '500', hex: '#d88ea6' },
      { name: '600', hex: '#c86c87' },
      { name: '700', hex: '#b95b72' },
      { name: '800', hex: '#9a3c50' },
      { name: '900', hex: '#803444' },
      { name: '1000', hex: '#6c2f3c' },
      { name: '1100', hex: '#40171f' },
    ],
  },
  {
    inputColorHex: '#9c6da6',
    inputColorName: 'wisteria',
    shades: [
      { name: '100', hex: '#fbf8fb' },
      { name: '200', hex: '#f5eff8' },
      { name: '300', hex: '#ebdfef' },
      { name: '400', hex: '#dbc5e2' },
      { name: '500', hex: '#c6a3cf' },
      { name: '600', hex: '#ac7db8' },
      { name: '700', hex: '#9c6da6' },
      { name: '800', hex: '#784c7f' },
      { name: '900', hex: '#623f69' },
      { name: '1000', hex: '#543857' },
      { name: '1100', hex: '#331c36' },
    ],
  },
  {
    inputColorHex: '#8e61c1',
    inputColorName: 'amethyst',
    shades: [
      { name: '100', hex: '#f8f6fc' },
      { name: '200', hex: '#f1eef9' },
      { name: '300', hex: '#e5e0f4' },
      { name: '400', hex: '#d2c6ec' },
      { name: '500', hex: '#baa5e0' },
      { name: '600', hex: '#a181d1' },
      { name: '700', hex: '#8e61c1' },
      { name: '800', hex: '#7f52af' },
      { name: '900', hex: '#6b4493' },
      { name: '1000', hex: '#583a78' },
      { name: '1100', hex: '#392451' },
    ],
  },
  {
    inputColorHex: '#5164a4',
    inputColorName: 'waikawa-gray',
    shades: [
      { name: '100', hex: '#f3f7fb' },
      { name: '200', hex: '#e5ebf4' },
      { name: '300', hex: '#d1dcec' },
      { name: '400', hex: '#b0c5e0' },
      { name: '500', hex: '#8ba7cf' },
      { name: '600', hex: '#6f8cc2' },
      { name: '700', hex: '#5c75b4' },
      { name: '800', hex: '#5164a4' },
      { name: '900', hex: '#465387' },
      { name: '1000', hex: '#3c466c' },
      { name: '1100', hex: '#282d43' },
    ],
  },
  {
    inputColorHex: '#6891ad',
    inputColorName: 'bermuda-gray',
    shades: [
      { name: '100', hex: '#f2f6f9' },
      { name: '200', hex: '#dee8ef' },
      { name: '300', hex: '#c1d4e0' },
      { name: '400', hex: '#97b5c9' },
      { name: '500', hex: '#6891ad' },
      { name: '600', hex: '#497291' },
      { name: '700', hex: '#405f7a' },
      { name: '800', hex: '#395065' },
      { name: '900', hex: '#344556' },
      { name: '1000', hex: '#2f3c4a' },
      { name: '1100', hex: '#1c2530' },
    ],
  },
  {
    inputColorHex: '#547170',
    inputColorName: 'cutty-sark',
    shades: [
      { name: '100', hex: '#f5f8f7' },
      { name: '200', hex: '#dfe8e7' },
      { name: '300', hex: '#bfd0ce' },
      { name: '400', hex: '#97b1af' },
      { name: '500', hex: '#71908e' },
      { name: '600', hex: '#547170' },
      { name: '700', hex: '#445d5d' },
      { name: '800', hex: '#394c4b' },
      { name: '900', hex: '#303f3f' },
      { name: '1000', hex: '#2b3636' },
      { name: '1100', hex: '#161c1d' },
    ],
  },
  {
    inputColorHex: '#355f4e',
    inputColorName: 'stromboli',
    shades: [
      { name: '100', hex: '#f2f7f5' },
      { name: '200', hex: '#dfece4' },
      { name: '300', hex: '#c1d9cc' },
      { name: '400', hex: '#98bdab' },
      { name: '500', hex: '#6b9c85' },
      { name: '600', hex: '#4b7e68' },
      { name: '700', hex: '#355f4e' },
      { name: '800', hex: '#2c5043' },
      { name: '900', hex: '#254035' },
      { name: '1000', hex: '#1f352d' },
      { name: '1100', hex: '#111d19' },
    ],
  },
  {
    inputColorHex: '#43663f',
    inputColorName: 'killarney',
    shades: [
      { name: '100', hex: '#f4f9f4' },
      { name: '200', hex: '#e9f1e7' },
      { name: '300', hex: '#d2e3cf' },
      { name: '400', hex: '#adcca9' },
      { name: '500', hex: '#82ac7c' },
      { name: '600', hex: '#5f8e59' },
      { name: '700', hex: '#4a7445' },
      { name: '800', hex: '#43663f' },
      { name: '900', hex: '#334b30' },
      { name: '1000', hex: '#2b3e29' },
      { name: '1100', hex: '#142013' },
    ],
  },
  {
    inputColorHex: '#748648',
    inputColorName: 'wasabi',
    shades: [
      { name: '100', hex: '#f5f7ee' },
      { name: '200', hex: '#e9edda' },
      { name: '300', hex: '#d4dcba' },
      { name: '400', hex: '#b8c690' },
      { name: '500', hex: '#9daf6c' },
      { name: '600', hex: '#748648' },
      { name: '700', hex: '#63743c' },
      { name: '800', hex: '#4c5a31' },
      { name: '900', hex: '#3f492b' },
      { name: '1000', hex: '#363f28' },
      { name: '1100', hex: '#1c2112' },
    ],
  },
  {
    inputColorHex: '#997200',
    inputColorName: 'buttered-rum',
    shades: [
      { name: '100', hex: '#faffe5' },
      { name: '200', hex: '#f1ffbc' },
      { name: '300', hex: '#e8ff7c' },
      { name: '400', hex: '#e3ff32' },
      { name: '500', hex: '#ebff00' },
      { name: '600', hex: '#fff800' },
      { name: '700', hex: '#e1c300' },
      { name: '800', hex: '#b38c00' },
      { name: '900', hex: '#997200' },
      { name: '1000', hex: '#7c5707' },
      { name: '1100', hex: '#492f00' },
    ],
  },
  {
    inputColorHex: '#995408',
    inputColorName: 'chelsea-gem',
    shades: [
      { name: '100', hex: '#fefbe8' },
      { name: '200', hex: '#fdf5c4' },
      { name: '300', hex: '#fde78b' },
      { name: '400', hex: '#fbd349' },
      { name: '500', hex: '#f8bc17' },
      { name: '600', hex: '#e8a30a' },
      { name: '700', hex: '#c87c06' },
      { name: '800', hex: '#995408' },
      { name: '900', hex: '#84450f' },
      { name: '1000', hex: '#703913' },
      { name: '1100', hex: '#411c07' },
    ],
  },
  {
    inputColorHex: '#992f02',
    inputColorName: 'cognac',
    shades: [
      { name: '100', hex: '#fff8ea' },
      { name: '200', hex: '#fff0cf' },
      { name: '300', hex: '#ffdc9d' },
      { name: '400', hex: '#ffc15f' },
      { name: '500', hex: '#ff991f' },
      { name: '600', hex: '#ff7800' },
      { name: '700', hex: '#ff5800' },
      { name: '800', hex: '#de3f00' },
      { name: '900', hex: '#af3200' },
      { name: '1000', hex: '#992f02' },
      { name: '1100', hex: '#4c1200' },
    ],
  },
  {
    inputColorHex: '#990c2f',
    inputColorName: 'paprika',
    shades: [
      { name: '100', hex: '#fff0f0' },
      { name: '200', hex: '#ffe2e2' },
      { name: '300', hex: '#ffcace' },
      { name: '400', hex: '#ff9ea5' },
      { name: '500', hex: '#ff6876' },
      { name: '600', hex: '#ff334a' },
      { name: '700', hex: '#ee1034' },
      { name: '800', hex: '#c9072a' },
      { name: '900', hex: '#a8092c' },
      { name: '1000', hex: '#990c2f' },
      { name: '1100', hex: '#510012' },
    ],
  },
  {
    inputColorHex: '#732085',
    inputColorName: 'seance',
    shades: [
      { name: '100', hex: '#fcf5fe' },
      { name: '200', hex: '#f7e9fe' },
      { name: '300', hex: '#efd3fb' },
      { name: '400', hex: '#e5b0f7' },
      { name: '500', hex: '#d781f1' },
      { name: '600', hex: '#c251e4' },
      { name: '700', hex: '#a831c8' },
      { name: '800', hex: '#8d25a6' },
      { name: '900', hex: '#732085' },
      { name: '1000', hex: '#63206f' },
      { name: '1100', hex: '#3f0949' },
    ],
  },
  {
    inputColorHex: '#531d91',
    inputColorName: 'daisy-bush',
    shades: [
      { name: '100', hex: '#f6f3ff' },
      { name: '200', hex: '#efe9fe' },
      { name: '300', hex: '#e0d6fe' },
      { name: '400', hex: '#c9b5fd' },
      { name: '500', hex: '#af8cf9' },
      { name: '600', hex: '#965df5' },
      { name: '700', hex: '#893bec' },
      { name: '800', hex: '#7a29d8' },
      { name: '900', hex: '#6622b5' },
      { name: '1000', hex: '#531d91' },
      { name: '1100', hex: '#341065' },
    ],
  },
  {
    inputColorHex: '#182f7b',
    inputColorName: 'catalina-blue',
    shades: [
      { name: '100', hex: '#eff6ff' },
      { name: '200', hex: '#dae9ff' },
      { name: '300', hex: '#bed9ff' },
      { name: '400', hex: '#90c2ff' },
      { name: '500', hex: '#5ca1fe' },
      { name: '600', hex: '#377cfa' },
      { name: '700', hex: '#205bf0' },
      { name: '800', hex: '#1947dc' },
      { name: '900', hex: '#1b3ab2' },
      { name: '1000', hex: '#182f7b' },
      { name: '1100', hex: '#162255' },
    ],
  },
  {
    inputColorHex: '#0d5f99',
    inputColorName: 'matisse',
    shades: [
      { name: '100', hex: '#f1f8fe' },
      { name: '200', hex: '#e2f0fc' },
      { name: '300', hex: '#bee1f9' },
      { name: '400', hex: '#85c9f4' },
      { name: '500', hex: '#44aeec' },
      { name: '600', hex: '#1c95db' },
      { name: '700', hex: '#0e76bb' },
      { name: '800', hex: '#0d5f99' },
      { name: '900', hex: '#0f507d' },
      { name: '1000', hex: '#124368' },
      { name: '1100', hex: '#0c2b45' },
    ],
  },
  {
    inputColorHex: '#1d5956',
    inputColorName: 'eden',
    shades: [
      { name: '100', hex: '#f2fbf9' },
      { name: '200', hex: '#d2f5ee' },
      { name: '300', hex: '#a5eadd' },
      { name: '400', hex: '#71d7c9' },
      { name: '500', hex: '#43beb0' },
      { name: '600', hex: '#2aa297' },
      { name: '700', hex: '#1f827a' },
      { name: '800', hex: '#1d6863' },
      { name: '900', hex: '#1d5956' },
      { name: '1000', hex: '#1b4644' },
      { name: '1100', hex: '#0a2929' },
    ],
  },
  {
    inputColorHex: '#014228',
    inputColorName: 'zuccini',
    shades: [
      { name: '100', hex: '#ebfef2' },
      { name: '200', hex: '#cefddf' },
      { name: '300', hex: '#a2f8c4' },
      { name: '400', hex: '#66efa6' },
      { name: '500', hex: '#2add84' },
      { name: '600', hex: '#05c46b' },
      { name: '700', hex: '#00a057' },
      { name: '800', hex: '#008049' },
      { name: '900', hex: '#00653b' },
      { name: '1000', hex: '#014228' },
      { name: '1100', hex: '#002f1d' },
    ],
  },
  {
    inputColorHex: '#0d6102',
    inputColorName: 'san-felix',
    shades: [
      { name: '100', hex: '#edffe0' },
      { name: '200', hex: '#d5ffbd' },
      { name: '300', hex: '#acff83' },
      { name: '400', hex: '#76ff3c' },
      { name: '500', hex: '#44ff03' },
      { name: '600', hex: '#23ff00' },
      { name: '700', hex: '#15ce00' },
      { name: '800', hex: '#0f9b00' },
      { name: '900', hex: '#0f7900' },
      { name: '1000', hex: '#0d6102' },
      { name: '1100', hex: '#013a00' },
    ],
  },
  {
    inputColorHex: '#587c00',
    inputColorName: 'fern-frond',
    shades: [
      { name: '100', hex: '#fdffe2' },
      { name: '200', hex: '#f9ffc0' },
      { name: '300', hex: '#f1ff88' },
      { name: '400', hex: '#e3ff44' },
      { name: '500', hex: '#d1ff0d' },
      { name: '600', hex: '#b1f500' },
      { name: '700', hex: '#88c500' },
      { name: '800', hex: '#669500' },
      { name: '900', hex: '#587c00' },
      { name: '1000', hex: '#446106' },
      { name: '1100', hex: '#223700' },
    ],
  },
  {
    inputColorHex: '#664c00',
    inputColorName: 'horses-neck',
    shades: [
      { name: '100', hex: '#f8ffe4' },
      { name: '200', hex: '#ecffb8' },
      { name: '300', hex: '#d9ff74' },
      { name: '400', hex: '#ccff25' },
      { name: '500', hex: '#d3ff00' },
      { name: '600', hex: '#f0ff00' },
      { name: '700', hex: '#f0d800' },
      { name: '800', hex: '#be9b00' },
      { name: '900', hex: '#9c7800' },
      { name: '1000', hex: '#664c00' },
      { name: '1100', hex: '#4d3300' },
    ],
  },
  {
    inputColorHex: '#663806',
    inputColorName: 'nutmeg-wood-finish',
    shades: [
      { name: '100', hex: '#ffffe6' },
      { name: '200', hex: '#fcffbc' },
      { name: '300', hex: '#feff7d' },
      { name: '400', hex: '#fff832' },
      { name: '500', hex: '#ffe700' },
      { name: '600', hex: '#ffcc00' },
      { name: '700', hex: '#e09d00' },
      { name: '800', hex: '#b26d00' },
      { name: '900', hex: '#925501' },
      { name: '1000', hex: '#663806' },
      { name: '1100', hex: '#492200' },
    ],
  },
  {
    inputColorHex: '#662001',
    inputColorName: 'cedar-wood-finish',
    shades: [
      { name: '100', hex: '#fff9eb' },
      { name: '200', hex: '#fff2d1' },
      { name: '300', hex: '#ffe0a1' },
      { name: '400', hex: '#ffc866' },
      { name: '500', hex: '#ffa328' },
      { name: '600', hex: '#ff8600' },
      { name: '700', hex: '#ff6800' },
      { name: '800', hex: '#d54c00' },
      { name: '900', hex: '#a83c04' },
      { name: '1000', hex: '#873407' },
      { name: '1100', hex: '#662001' },
    ],
  },
  {
    inputColorHex: '#660820',
    inputColorName: 'bordeaux',
    shades: [
      { name: '100', hex: '#fff1f2' },
      { name: '200', hex: '#ffe4e5' },
      { name: '300', hex: '#fdced2' },
      { name: '400', hex: '#fca5ae' },
      { name: '500', hex: '#f97382' },
      { name: '600', hex: '#f2415a' },
      { name: '700', hex: '#df1f44' },
      { name: '800', hex: '#bc1439' },
      { name: '900', hex: '#9d1436' },
      { name: '1000', hex: '#871435' },
      { name: '1100', hex: '#660820' },
    ],
  },
  {
    inputColorHex: '#4d1658',
    inputColorName: 'clairvoyant',
    shades: [
      { name: '100', hex: '#fbf6fd' },
      { name: '200', hex: '#f6ecfb' },
      { name: '300', hex: '#edd8f6' },
      { name: '400', hex: '#e0b9ee' },
      { name: '500', hex: '#ce8ee4' },
      { name: '600', hex: '#b762d3' },
      { name: '700', hex: '#9c43b6' },
      { name: '800', hex: '#833596' },
      { name: '900', hex: '#6c2d7b' },
      { name: '1000', hex: '#5b2966' },
      { name: '1100', hex: '#4d1658' },
    ],
  },
  {
    inputColorHex: '#381460',
    inputColorName: 'jagger',
    shades: [
      { name: '100', hex: '#f9f6fe' },
      { name: '200', hex: '#f2ebfc' },
      { name: '300', hex: '#e6dafa' },
      { name: '400', hex: '#d3bdf5' },
      { name: '500', hex: '#b893ed' },
      { name: '600', hex: '#9e69e3' },
      { name: '700', hex: '#864ad3' },
      { name: '800', hex: '#7237b9' },
      { name: '900', hex: '#603297' },
      { name: '1000', hex: '#4f297a' },
      { name: '1100', hex: '#381460' },
    ],
  },
  {
    inputColorHex: '#101f52',
    inputColorName: 'bunting',
    shades: [
      { name: '100', hex: '#eef6ff' },
      { name: '200', hex: '#d8eaff' },
      { name: '300', hex: '#b9daff' },
      { name: '400', hex: '#89c4ff' },
      { name: '500', hex: '#52a4ff' },
      { name: '600', hex: '#2a7eff' },
      { name: '700', hex: '#135bfd' },
      { name: '800', hex: '#0c46e9' },
      { name: '900', hex: '#1139bc' },
      { name: '1000', hex: '#143594' },
      { name: '1100', hex: '#101f52' },
    ],
  },
  {
    inputColorHex: '#094066',
    inputColorName: 'regal-blue',
    shades: [
      { name: '100', hex: '#f0f8ff' },
      { name: '200', hex: '#dff1ff' },
      { name: '300', hex: '#b9e3fe' },
      { name: '400', hex: '#7acfff' },
      { name: '500', hex: '#34b7fc' },
      { name: '600', hex: '#099eee' },
      { name: '700', hex: '#007dcb' },
      { name: '800', hex: '#0063a4' },
      { name: '900', hex: '#045588' },
      { name: '1000', hex: '#094066' },
      { name: '1100', hex: '#072c4a' },
    ],
  },
  {
    inputColorHex: '#143b39',
    inputColorName: 'gable-green',
    shades: [
      { name: '100', hex: '#f1fcf9' },
      { name: '200', hex: '#d0f7ef' },
      { name: '300', hex: '#a2ede0' },
      { name: '400', hex: '#6bddcd' },
      { name: '500', hex: '#3dc4b5' },
      { name: '600', hex: '#23a99c' },
      { name: '700', hex: '#1a8780' },
      { name: '800', hex: '#196c67' },
      { name: '900', hex: '#185754' },
      { name: '1000', hex: '#143b39' },
      { name: '1100', hex: '#082b2b' },
    ],
  },
  {
    inputColorHex: '#002c1a',
    inputColorName: 'burnham',
    shades: [
      { name: '100', hex: '#eefff6' },
      { name: '200', hex: '#d8ffed' },
      { name: '300', hex: '#b4fedb' },
      { name: '400', hex: '#79fcbf' },
      { name: '500', hex: '#38f09b' },
      { name: '600', hex: '#0ed97d' },
      { name: '700', hex: '#05b464' },
      { name: '800', hex: '#088d51' },
      { name: '900', hex: '#0c6f43' },
      { name: '1000', hex: '#0c5b39' },
      { name: '1100', hex: '#002c1a' },
    ],
  },
  {
    inputColorHex: '#094002',
    inputColorName: 'dark-fern',
    shades: [
      { name: '100', hex: '#eeffe5' },
      { name: '200', hex: '#d7ffc7' },
      { name: '300', hex: '#b1ff95' },
      { name: '400', hex: '#7ffe58' },
      { name: '500', hex: '#54f526' },
      { name: '600', hex: '#32db07' },
      { name: '700', hex: '#21b000' },
      { name: '800', hex: '#1b8506' },
      { name: '900', hex: '#1a690b' },
      { name: '1000', hex: '#19580f' },
      { name: '1100', hex: '#094002' },
    ],
  },
  {
    inputColorHex: '#3b5200',
    inputColorName: 'verdun-green',
    shades: [
      { name: '100', hex: '#fffee0' },
      { name: '200', hex: '#fdffbb' },
      { name: '300', hex: '#f9ff80' },
      { name: '400', hex: '#eeff37' },
      { name: '500', hex: '#dfff00' },
      { name: '600', hex: '#beff00' },
      { name: '700', hex: '#93d300' },
      { name: '800', hex: '#6f9f00' },
      { name: '900', hex: '#587b00' },
      { name: '1000', hex: '#3b5200' },
      { name: '1100', hex: '#253b00' },
    ],
  },
  {
    inputColorHex: '#332600',
    inputColorName: 'brown-tumbleweed',
    shades: [
      { name: '100', hex: '#f8ffe6' },
      { name: '200', hex: '#ebffbd' },
      { name: '300', hex: '#ddff7e' },
      { name: '400', hex: '#d3ff35' },
      { name: '500', hex: '#d4ff00' },
      { name: '600', hex: '#f0ff00' },
      { name: '700', hex: '#ded600' },
      { name: '800', hex: '#b09c00' },
      { name: '900', hex: '#917b02' },
      { name: '1000', hex: '#7a6209' },
      { name: '1100', hex: '#332600' },
    ],
  },
  {
    inputColorHex: '#331c03',
    inputColorName: 'jacko-bean',
    shades: [
      { name: '100', hex: '#ffffe7' },
      { name: '200', hex: '#feffc1' },
      { name: '300', hex: '#fffe86' },
      { name: '400', hex: '#fff541' },
      { name: '500', hex: '#ffe60d' },
      { name: '600', hex: '#f2cc00' },
      { name: '700', hex: '#d19e00' },
      { name: '800', hex: '#a67102' },
      { name: '900', hex: '#89580a' },
      { name: '1000', hex: '#74480f' },
      { name: '1100', hex: '#331c03' },
    ],
  },
  {
    inputColorHex: '#331001',
    inputColorName: 'rebel',
    shades: [
      { name: '100', hex: '#fff9eb' },
      { name: '200', hex: '#fff2d1' },
      { name: '300', hex: '#ffe0a2' },
      { name: '400', hex: '#ffc767' },
      { name: '500', hex: '#ffa22a' },
      { name: '600', hex: '#ff8401' },
      { name: '700', hex: '#ff6600' },
      { name: '800', hex: '#d34c00' },
      { name: '900', hex: '#a73c05' },
      { name: '1000', hex: '#863308' },
      { name: '1100', hex: '#331001' },
    ],
  },
  {
    inputColorHex: '#330410',
    inputColorName: 'temptress',
    shades: [
      { name: '100', hex: '#fff1f2' },
      { name: '200', hex: '#ffe4e5' },
      { name: '300', hex: '#fdced2' },
      { name: '400', hex: '#fca5ae' },
      { name: '500', hex: '#f97382' },
      { name: '600', hex: '#f2415a' },
      { name: '700', hex: '#df1f44' },
      { name: '800', hex: '#bc1439' },
      { name: '900', hex: '#9d1436' },
      { name: '1000', hex: '#871435' },
      { name: '1100', hex: '#330410' },
    ],
  },
  {
    inputColorHex: '#260b2c',
    inputColorName: 'revolver',
    shades: [
      { name: '100', hex: '#f5ecff' },
      { name: '200', hex: '#eddcff' },
      { name: '300', hex: '#e1bfff' },
      { name: '400', hex: '#d399ff' },
      { name: '500', hex: '#ce71ff' },
      { name: '600', hex: '#d04fff' },
      { name: '700', hex: '#d530fb' },
      { name: '800', hex: '#bf24de' },
      { name: '900', hex: '#9820b3' },
      { name: '1000', hex: '#75238c' },
      { name: '1100', hex: '#260b2c' },
    ],
  },
  {
    inputColorHex: '#1c0a30',
    inputColorName: 'haiti',
    shades: [
      { name: '100', hex: '#eeebff' },
      { name: '200', hex: '#dfdaff' },
      { name: '300', hex: '#c8bcff' },
      { name: '400', hex: '#ab94ff' },
      { name: '500', hex: '#986aff' },
      { name: '600', hex: '#8f47ff' },
      { name: '700', hex: '#8c27ff' },
      { name: '800', hex: '#7f1be7' },
      { name: '900', hex: '#6519ba' },
      { name: '1000', hex: '#511e91' },
      { name: '1100', hex: '#1c0a30' },
    ],
  },
  {
    inputColorHex: '#081029',
    inputColorName: 'midnight',
    shades: [
      { name: '100', hex: '#eaf6ff' },
      { name: '200', hex: '#d9efff' },
      { name: '300', hex: '#bbe0ff' },
      { name: '400', hex: '#92c9ff' },
      { name: '500', hex: '#67a5ff' },
      { name: '600', hex: '#4482ff' },
      { name: '700', hex: '#245aff' },
      { name: '800', hex: '#1949e9' },
      { name: '900', hex: '#173fbc' },
      { name: '1000', hex: '#1c3c93' },
      { name: '1100', hex: '#081029' },
    ],
  },
  {
    inputColorHex: '#042033',
    inputColorName: 'big-stone',
    shades: [
      { name: '100', hex: '#f0f9ff' },
      { name: '200', hex: '#dff2ff' },
      { name: '300', hex: '#b8e7ff' },
      { name: '400', hex: '#79d3ff' },
      { name: '500', hex: '#32befe' },
      { name: '600', hex: '#07a7f0' },
      { name: '700', hex: '#0085cd' },
      { name: '800', hex: '#0069a6' },
      { name: '900', hex: '#035989' },
      { name: '1000', hex: '#094b71' },
      { name: '1100', hex: '#042033' },
    ],
  },
  {
    inputColorHex: '#0a1e1d',
    inputColorName: 'aztec',
    shades: [
      { name: '100', hex: '#f3faf9' },
      { name: '200', hex: '#d6f1eb' },
      { name: '300', hex: '#ace3d7' },
      { name: '400', hex: '#7acebe' },
      { name: '500', hex: '#4fb2a3' },
      { name: '600', hex: '#359789' },
      { name: '700', hex: '#28796f' },
      { name: '800', hex: '#24615a' },
      { name: '900', hex: '#214e4a' },
      { name: '1000', hex: '#1f423f' },
      { name: '1100', hex: '#0a1e1d' },
    ],
  },
  {
    inputColorHex: '#00160d',
    inputColorName: 'black-bean',
    shades: [
      { name: '100', hex: '#ebfef2' },
      { name: '200', hex: '#cffcdd' },
      { name: '300', hex: '#a3f7c2' },
      { name: '400', hex: '#68eda1' },
      { name: '500', hex: '#2cdb7d' },
      { name: '600', hex: '#08c164' },
      { name: '700', hex: '#009d51' },
      { name: '800', hex: '#007e43' },
      { name: '900', hex: '#026337' },
      { name: '1000', hex: '#035130' },
      { name: '1100', hex: '#00160d' },
    ],
  },
  {
    inputColorHex: '#042001',
    inputColorName: 'palm-green',
    shades: [
      { name: '100', hex: '#f2feef' },
      { name: '200', hex: '#dfffd9' },
      { name: '300', hex: '#c2fcb6' },
      { name: '400', hex: '#8ff87d' },
      { name: '500', hex: '#57ea3e' },
      { name: '600', hex: '#30d314' },
      { name: '700', hex: '#21af0a' },
      { name: '800', hex: '#1d890c' },
      { name: '900', hex: '#1c6c0f' },
      { name: '1000', hex: '#17580f' },
      { name: '1100', hex: '#042001' },
    ],
  },
  {
    inputColorHex: '#585f66',
    inputColorName: 'shuttle-gray',
    shades: [
      { name: '100', hex: '#f5f6f6' },
      { name: '200', hex: '#e5e7e8' },
      { name: '300', hex: '#cdd1d4' },
      { name: '400', hex: '#aab1b6' },
      { name: '500', hex: '#808990' },
      { name: '600', hex: '#656e75' },
      { name: '700', hex: '#585f66' },
      { name: '800', hex: '#4a4f54' },
      { name: '900', hex: '#414549' },
      { name: '1000', hex: '#393c40' },
      { name: '1100', hex: '#242628' },
    ],
  },
  {
    inputColorHex: '#51575e',
    inputColorName: 'abbey',
    shades: [
      { name: '100', hex: '#f5f6f6' },
      { name: '200', hex: '#e5e7e8' },
      { name: '300', hex: '#cdd1d4' },
      { name: '400', hex: '#aab1b6' },
      { name: '500', hex: '#808890' },
      { name: '600', hex: '#656d75' },
      { name: '700', hex: '#51575e' },
      { name: '800', hex: '#4a4f54' },
      { name: '900', hex: '#414449' },
      { name: '1000', hex: '#393c40' },
      { name: '1100', hex: '#242628' },
    ],
  },
  {
    inputColorHex: '#4a5056',
    inputColorName: 'abbey',
    shades: [
      { name: '100', hex: '#f5f6f6' },
      { name: '200', hex: '#e4e7e9' },
      { name: '300', hex: '#cdd2d4' },
      { name: '400', hex: '#a9b1b7' },
      { name: '500', hex: '#7f8a91' },
      { name: '600', hex: '#646f76' },
      { name: '700', hex: '#555d65' },
      { name: '800', hex: '#4a5056' },
      { name: '900', hex: '#414549' },
      { name: '1000', hex: '#393c40' },
      { name: '1100', hex: '#232529' },
    ],
  },
  {
    inputColorHex: '#43484d',
    inputColorName: 'abbey',
    shades: [
      { name: '100', hex: '#f5f6f6' },
      { name: '200', hex: '#e4e7e9' },
      { name: '300', hex: '#ccd2d5' },
      { name: '400', hex: '#a9b2b7' },
      { name: '500', hex: '#7e8a92' },
      { name: '600', hex: '#636f77' },
      { name: '700', hex: '#555e65' },
      { name: '800', hex: '#495055' },
      { name: '900', hex: '#43484d' },
      { name: '1000', hex: '#393c40' },
      { name: '1100', hex: '#232529' },
    ],
  },
  {
    inputColorHex: '#3c4145',
    inputColorName: 'cape-cod',
    shades: [
      { name: '100', hex: '#f4f5f7' },
      { name: '200', hex: '#e4e8e9' },
      { name: '300', hex: '#ccd2d5' },
      { name: '400', hex: '#a8b3b8' },
      { name: '500', hex: '#7d8c93' },
      { name: '600', hex: '#627178' },
      { name: '700', hex: '#546066' },
      { name: '800', hex: '#485156' },
      { name: '900', hex: '#40464a' },
      { name: '1000', hex: '#3c4145' },
      { name: '1100', hex: '#232629' },
    ],
  },
  {
    inputColorHex: '#35393d',
    inputColorName: 'mine-shaft',
    shades: [
      { name: '100', hex: '#f4f5f7' },
      { name: '200', hex: '#e4e8e9' },
      { name: '300', hex: '#ccd2d5' },
      { name: '400', hex: '#a8b2b8' },
      { name: '500', hex: '#7d8b93' },
      { name: '600', hex: '#627078' },
      { name: '700', hex: '#545f66' },
      { name: '800', hex: '#485056' },
      { name: '900', hex: '#40464a' },
      { name: '1000', hex: '#35393d' },
      { name: '1100', hex: '#232629' },
    ],
  },
  {
    inputColorHex: '#2e3135',
    inputColorName: 'mine-shaft',
    shades: [
      { name: '100', hex: '#f4f5f7' },
      { name: '200', hex: '#e4e8e9' },
      { name: '300', hex: '#ccd1d5' },
      { name: '400', hex: '#a8b1b8' },
      { name: '500', hex: '#7d8993' },
      { name: '600', hex: '#626e78' },
      { name: '700', hex: '#545e66' },
      { name: '800', hex: '#484f56' },
      { name: '900', hex: '#40454a' },
      { name: '1000', hex: '#2e3135' },
      { name: '1100', hex: '#232529' },
    ],
  },
  {
    inputColorHex: '#272a2d',
    inputColorName: 'shark',
    shades: [
      { name: '100', hex: '#f5f6f6' },
      { name: '200', hex: '#e4e6e9' },
      { name: '300', hex: '#cdd2d4' },
      { name: '400', hex: '#a9b1b7' },
      { name: '500', hex: '#7f8991' },
      { name: '600', hex: '#646e76' },
      { name: '700', hex: '#555d65' },
      { name: '800', hex: '#494e55' },
      { name: '900', hex: '#414449' },
      { name: '1000', hex: '#393c40' },
      { name: '1100', hex: '#202225' },
    ],
  },
  {
    inputColorHex: '#202225',
    inputColorName: 'shark',
    shades: [
      { name: '100', hex: '#f5f6f6' },
      { name: '200', hex: '#e4e6e9' },
      { name: '300', hex: '#cdd2d4' },
      { name: '400', hex: '#a9b1b7' },
      { name: '500', hex: '#7f8991' },
      { name: '600', hex: '#646e76' },
      { name: '700', hex: '#555d65' },
      { name: '800', hex: '#494e55' },
      { name: '900', hex: '#414449' },
      { name: '1000', hex: '#393c40' },
      { name: '1100', hex: '#202225' },
    ],
  },
  {
    inputColorHex: '#191b1d',
    inputColorName: 'bunker',
    shades: [
      { name: '100', hex: '#f5f6f6' },
      { name: '200', hex: '#e4e7e9' },
      { name: '300', hex: '#ccd2d5' },
      { name: '400', hex: '#a9b2b7' },
      { name: '500', hex: '#7e8b92' },
      { name: '600', hex: '#637077' },
      { name: '700', hex: '#555f65' },
      { name: '800', hex: '#494f55' },
      { name: '900', hex: '#40454a' },
      { name: '1000', hex: '#393c40' },
      { name: '1100', hex: '#191b1d' },
    ],
  },
  {
    inputColorHex: '#121314',
    inputColorName: 'woodsmoke',
    shades: [
      { name: '100', hex: '#f5f6f6' },
      { name: '200', hex: '#e5e7e8' },
      { name: '300', hex: '#ced2d3' },
      { name: '400', hex: '#abb2b5' },
      { name: '500', hex: '#818a8f' },
      { name: '600', hex: '#666f74' },
      { name: '700', hex: '#575d63' },
      { name: '800', hex: '#4b4f53' },
      { name: '900', hex: '#424648' },
      { name: '1000', hex: '#3a3d3f' },
      { name: '1100', hex: '#121314' },
    ],
  },
  {
    inputColorHex: '#121212',
    inputColorName: 'cod-gray',
    shades: [
      { name: '100', hex: '#f6f6f6' },
      { name: '200', hex: '#e7e7e7' },
      { name: '300', hex: '#d1d1d1' },
      { name: '400', hex: '#b0b0b0' },
      { name: '500', hex: '#888888' },
      { name: '600', hex: '#6d6d6d' },
      { name: '700', hex: '#5d5d5d' },
      { name: '800', hex: '#4f4f4f' },
      { name: '900', hex: '#454545' },
      { name: '1000', hex: '#3d3d3d' },
      { name: '1100', hex: '#121212' },
    ],
  },
  {
    inputColorHex: '#5a03d5',
    inputColorName: 'purple-heart',
    shades: [
      { name: '100', hex: '#f3f1ff' },
      { name: '200', hex: '#ebe5ff' },
      { name: '300', hex: '#d9ceff' },
      { name: '400', hex: '#bea6ff' },
      { name: '500', hex: '#9f75ff' },
      { name: '600', hex: '#843dff' },
      { name: '700', hex: '#7916ff' },
      { name: '800', hex: '#6b04fd' },
      { name: '900', hex: '#5a03d5' },
      { name: '1000', hex: '#4b05ad' },
      { name: '1100', hex: '#2c0076' },
    ],
  },
  {
    inputColorHex: '#e63f66',
    inputColorName: 'cerise-red',
    shades: [
      { name: '100', hex: '#fef2f4' },
      { name: '200', hex: '#fde6e9' },
      { name: '300', hex: '#fbd0d9' },
      { name: '400', hex: '#f7aab9' },
      { name: '500', hex: '#f27a93' },
      { name: '600', hex: '#e63f66' },
      { name: '700', hex: '#d42a5b' },
      { name: '800', hex: '#b21e4b' },
      { name: '900', hex: '#951c45' },
      { name: '1000', hex: '#801b40' },
      { name: '1100', hex: '#470a1f' },
    ],
  },
  {
    inputColorHex: '#438e96',
    inputColorName: 'blue-chill',
    shades: [
      { name: '100', hex: '#f2f9f9' },
      { name: '200', hex: '#ddeff0' },
      { name: '300', hex: '#bfe0e2' },
      { name: '400', hex: '#92cace' },
      { name: '500', hex: '#5faab1' },
      { name: '600', hex: '#438e96' },
      { name: '700', hex: '#3b757f' },
      { name: '800', hex: '#356169' },
      { name: '900', hex: '#325158' },
      { name: '1000', hex: '#2d464c' },
      { name: '1100', hex: '#1a2c32' },
    ],
  },
  {
    inputColorHex: '#3E3775',
    inputColorName: 'minsk',
    shades: [
      { name: '100', hex: '#f0f2fd' },
      { name: '200', hex: '#e4e7fb' },
      { name: '300', hex: '#ced3f7' },
      { name: '400', hex: '#afb6f2' },
      { name: '500', hex: '#8f91ea' },
      { name: '600', hex: '#7a74e0' },
      { name: '700', hex: '#6959d2' },
      { name: '800', hex: '#5a4ab8' },
      { name: '900', hex: '#4a3e95' },
      { name: '1000', hex: '#3e3775' },
      { name: '1100', hex: '#262145' },
    ],
  },
  {
    inputColorHex: '#4af196',
    inputColorName: 'spring-green',
    shades: [
      { name: '100', hex: '#f4fff9' },
      { name: '200', hex: '#e6fff1' },
      { name: '300', hex: '#cffee4' },
      { name: '400', hex: '#abfcd0' },
      { name: '500', hex: '#8df5bc' },
      { name: '600', hex: '#4af196' },
      { name: '700', hex: '#09f375' },
      { name: '800', hex: '#0cbf5f' },
      { name: '900', hex: '#139550' },
      { name: '1000', hex: '#117b44' },
      { name: '1100', hex: '#004624' },
    ],
  },
  ...DEFAULT_ELEMENT_COLOR_PALETTES,
] as const;
